//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp
  },

  props: {
    tool: {
      type: Object,
      required: true
    },

    basePath: {
      type: String,
      required: true
    }
  },

  computed: {
    toolPath() {
      const { category, sub_category, slug } = this.tool
      const subCategorySlug = sub_category
        ? sub_category.slug
        : 'sem-subcategoria'
      const categorySlug = category ? category.slug : 'sem-categoria'

      return this.localePath(
        `${this.basePath}/${categorySlug}/${subCategorySlug}/${slug}`
      )
    }
  }
}
